import { AxiosInstance, InternalAxiosRequestConfig, AxiosRequestHeaders } from "axios";

let csrfToken: string;

const getCsrfToken = (): string => {
    if (!csrfToken) {
        csrfToken = (document.getElementsByName("__RequestVerificationToken")[0] as HTMLInputElement)?.value || "";
    }
    return csrfToken;
};

export const csrfInterceptor = (config: InternalAxiosRequestConfig) => {
    config.headers ??= {} as AxiosRequestHeaders;
    config.headers["X-CSRF-TOKEN"] = getCsrfToken();

    return config;
};

export const addCsrfInterceptor = (httpClient: AxiosInstance) => {
    httpClient.interceptors.request.use(csrfInterceptor, null, { synchronous: true });
};
